<lib-page-header title="IP Blocklist" icon="block"></lib-page-header>

<div class="ip-blacklist-page">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>Block an IP</mat-card-title>
      <mat-card-subtitle>
        Adds an entry to the gateway blocklist. Requests from this address will receive 403.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="blockForm" (ngSubmit)="block()">
        <mat-form-field appearance="outline" class="full">
          <mat-label>IP address (or CIDR)</mat-label>
          <mat-icon matPrefix class="field-icon">router</mat-icon>
          <input matInput formControlName="ip" placeholder="e.g. 203.0.113.45 or 203.0.113.0/24" />
          <mat-error *ngIf="blockForm.controls.ip.hasError('required')">IP is required</mat-error>
          <mat-error *ngIf="blockForm.controls.ip.hasError('wildcardIp')">
            Wildcard ranges (0.0.0.0 or /0) belong at the firewall, not the application blocklist
          </mat-error>
          <mat-error *ngIf="blockForm.controls.ip.hasError('invalidIp')">Not a valid IPv4/IPv6 address</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full">
          <mat-label>Reason</mat-label>
          <mat-icon matPrefix class="field-icon">info</mat-icon>
          <input matInput formControlName="reason" maxlength="200" placeholder="why this address is being blocked" />
          <mat-error *ngIf="blockForm.controls.reason.hasError('required')">Reason is required</mat-error>
        </mat-form-field>

        <div class="actions">
          <button mat-flat-button color="warn" type="submit"
                  *ngIf="permissionChecker.hasAccessToBlockIp()"
                  [disabled]="blocking || blockForm.invalid">
            <mat-icon>block</mat-icon>
            Block IP
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>Unblock an IP</mat-card-title>
      <mat-card-subtitle>
        Removes the entry from the gateway blocklist. Subsequent requests are accepted again.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="unblockForm" (ngSubmit)="unblock()">
        <mat-form-field appearance="outline" class="full">
          <mat-label>IP address (or CIDR)</mat-label>
          <input matInput formControlName="ip" />
          <mat-error *ngIf="unblockForm.controls.ip.hasError('required')">IP is required</mat-error>
          <mat-error *ngIf="unblockForm.controls.ip.hasError('invalidIp')">Not a valid IPv4/IPv6 address</mat-error>
        </mat-form-field>

        <div class="actions">
          <button mat-stroked-button type="submit"
                  *ngIf="permissionChecker.hasAccessToUnblockIp()"
                  [disabled]="unblocking || unblockForm.invalid">
            <mat-icon>lock_open</mat-icon>
            Unblock IP
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="card hint">
    <mat-card-content>
      Audit history of every block / unblock action lives in the
      <a routerLink="/reports/audit-report">audit report</a>
      filtered by entity = <code>IpBlacklist</code>.
    </mat-card-content>
  </mat-card>
</div>
